var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoice2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "820px",
    height: "726px",
    viewBox: "0 0 820 726",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "voice2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "voice2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    cx: 426.15967,
    cy: 350.30375,
    r: 350.30375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.41627,597.79884 C176.85135,632.40321 183.03416,676.41552 183.03416,676.41552 C183.03416,676.41552 225.80194,664.32306 248.36686,629.71869 C270.93178,595.11432 264.749,551.10201 264.749,551.10201 C264.749,551.10201 221.9812,563.19447 199.41627,597.79884 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.91411,676.01309 C182.91411,676.01309 182.36479,675.92545 181.35378,675.7209 C180.54733,675.55729 179.43702,675.32352 178.08125,675.00212 C165.96115,672.14448 133.73825,662.48464 112.67125,637.08733 C86.30388,605.28521 87.41419,560.85454 87.41419,560.85454 C87.41419,560.85454 127.73082,567.40549 154.29686,595.96429 C155.448113,597.191483 156.56818,598.463483 157.65706,599.78029 C180.59995,627.45085 182.73878,664.68192 182.90827,673.88595 C182.93162,675.2651 182.91411,676.01309 182.91411,676.01309 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.652,597.79884 C189.21692,632.40321 183.03412,676.41552 183.03412,676.41552 C183.03412,676.41552 140.26633,664.32306 117.70141,629.71869 C95.13649,595.11432 101.31929,551.10201 101.31929,551.10201 C101.31929,551.10201 144.08711,563.19447 166.652,597.79884 Z",
    id: "Path",
    stroke: "#3F3D56",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.90826,673.88596 C182.31218,674.60474 181.78626,675.21834 181.35378,675.7209 C180.39542,676.81369 179.85191,677.38641 179.85191,677.38641 C179.85191,677.38641 179.19159,676.55656 178.08125,675.00212 C171.98614,666.5052 152.38009,636.29258 153.89362,601.3932 C153.97544,599.56408 154.10985,597.754443 154.29685,595.96429 C155.448103,597.191483 156.56817,598.463483 157.65705,599.78029 C180.59994,627.45086 182.73877,664.68193 182.90826,673.88596 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.36616,603.917 C214.58258,645.18996 183.94478,677.38676 183.94478,677.38676 C183.94478,677.38676 156.19878,642.6669 157.98233,601.39394 C159.76588,560.12098 190.40372,527.92415 190.40372,527.92415 C190.40372,527.92415 218.14975,562.64404 216.36616,603.917 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.94478,
    y1: 676.21802,
    x2: 190.68055,
    y2: 529.60758,
    id: "Path",
    stroke: "#3F3D56",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 410,
    cy: 691.70413,
    rx: 410,
    ry: 33.46939
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.792148,225.550273 C416.368823,230.832401 397.866205,243.18695 393.683964,259.382043 C391.745294,266.889169 392.933883,274.693283 391.30245,282.243131 C387.518796,299.752926 369.571572,313.125264 353.018315,325.546268 C336.465058,337.967272 319.370693,352.399953 318.162643,370.123757 C316.839706,389.531737 335.218685,407.713887 332.038357,426.995063 C328.343476,449.395831 297.449303,463.911156 289.812245,485.719275 C284.712627,500.281515 290.961673,515.967936 301.242827,528.825542 C320.834672,553.326966 354.32307,569.960956 389.985647,578.878128 C425.648224,587.7953 463.629757,589.671343 501.142971,589.972357 C546.819645,590.338877 596.412563,587.33573 630.731743,564.24876 C650.335186,550.943195 662.646324,532.454208 665.196739,512.488893 C668.457048,485.746053 653.882462,458.113546 663.935681,432.381533 C670.26261,416.18722 686.129023,401.39723 683.761156,384.591127 C681.445976,368.158934 662.705892,356.51149 649.849854,343.236593 C637.846416,330.842152 630.562709,316.204981 623.42416,301.774473 L598.999115,252.399627 C594.197584,242.693395 588.925037,232.485009 578.224596,226.11446 C558.192465,214.188357 525.981568,216.53159 502.557718,218.991314 C480.827339,221.273218 457.689547,220.145502 436.792148,225.550273 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.98972,384.13661 C478.98972,384.13661 484.4088,401.74861 443.76567,422.0702 C403.12254,442.39179 447.82998,464.0681 447.82998,464.0681 L495.24698,474.90627 C495.24698,474.90627 544.01874,468.13242 549.43783,460.00379 C554.85692,451.87516 564.34031,424.77979 561.63077,420.71543 C559.603476,417.821691 557.337615,415.10265 554.8569,412.58676 C554.8569,412.58676 522.34239,407.16768 523.69717,392.2652 C525.05195,377.36272 478.98972,384.13661 478.98972,384.13661 Z",
    id: "Path",
    fill: "#FFB9B9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.98972,384.13661 C478.98972,384.13661 484.4088,401.74861 443.76567,422.0702 C403.12254,442.39179 447.82998,464.0681 447.82998,464.0681 L495.24698,474.90627 C495.24698,474.90627 544.01874,468.13242 549.43783,460.00379 C554.85692,451.87516 564.34031,424.77979 561.63077,420.71543 C559.603476,417.821691 557.337615,415.10265 554.8569,412.58676 C554.8569,412.58676 522.34239,407.16768 523.69717,392.2652 C525.05195,377.36272 478.98972,384.13661 478.98972,384.13661 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB9B9",
    fillRule: "nonzero",
    cx: 496.5,
    cy: 342.5,
    r: 86.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.66606,460.00376 C500.66606,460.00376 448.45554,456.18549 447.46537,420.16103 C447.46537,420.16103 428.86319,418.00586 423.4441,423.42494 C418.02501,428.84402 400.413,432.90834 400.413,446.45605 C400.413,460.00376 430.218,500.64689 430.218,500.64689 C430.218,500.64689 446.47525,554.83774 439.7014,564.32113 C432.92755,573.80452 431.57277,598.19041 431.57277,598.19041 C431.57277,598.19041 499.31133,592.77133 510.14949,598.19041 C520.98765,603.60949 564.34034,603.60949 567.04988,598.19041 C569.75942,592.77133 564.3403,525.03276 564.3403,525.03276 C564.3403,525.03276 576.53324,508.77551 573.8237,489.80871 L606.3382,451.87512 C606.3382,451.87512 594.14526,415.2963 575.17847,415.2963 C575.17847,415.2963 549.43782,408.52245 548.76047,411.90938 C548.08312,415.29631 561.63076,453.22993 500.66606,460.00376 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.73666,579.22365 C378.73666,579.22365 390.9296,598.19044 422.08933,602.25475 C453.24906,606.31906 458.66815,595.4809 455.95861,592.77136 C453.24907,590.06182 420.73456,577.86887 420.73456,577.86887 L401.76777,562.96639 L378.73666,579.22365 Z",
    id: "Path",
    fill: "#FFB9B9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.91912,562.96639 L565.69507,583.28796 C565.69507,583.28796 519.63285,580.57842 537.24488,594.12613 C554.85691,607.67384 587.37141,602.25475 587.37141,602.25475 L618.53114,587.35227 L600.91912,562.96639 Z",
    id: "Path",
    fill: "#FFB9B9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.79888,598.19044 C424.79888,598.19044 392.28437,678.12193 431.57273,690.31487 C470.86109,702.50781 579.24278,699.79827 603.62866,683.54102 C628.01454,667.28377 634.78839,645.60743 630.72408,638.83357 C626.65977,632.05971 599.56435,613.09292 580.59755,611.73815 C561.63075,610.38338 424.79888,598.19044 424.79888,598.19044 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.79888,598.19044 C424.79888,598.19044 392.28437,678.12193 431.57273,690.31487 C470.86109,702.50781 579.24278,699.79827 603.62866,683.54102 C628.01454,667.28377 634.78839,645.60743 630.72408,638.83357 C626.65977,632.05971 599.56435,613.09292 580.59755,611.73815 C561.63075,610.38338 424.79888,598.19044 424.79888,598.19044 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.27664,603.15633 C578.27664,603.15633 693.04355,561.61162 691.68878,611.73815 C690.33401,661.86468 618.53114,675.41239 618.53114,675.41239 L596.8548,678.12193 L477.635,682.18625 C477.635,682.18625 481.69931,660.50991 472.21591,657.80037 C472.21591,657.80037 503.37565,649.67174 504.73042,648.31697 C506.08519,646.9622 583.30714,619.86678 588.72623,618.51197 C594.14532,617.15716 610.40256,606.31903 622.5955,607.6738 C622.5955,607.6738 636.14322,596.83563 651.0457,599.54517 L609.04774,602.25476 L578.27664,603.15633 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.27664,603.15633 C578.27664,603.15633 693.04355,561.61162 691.68878,611.73815 C690.33401,661.86468 618.53114,675.41239 618.53114,675.41239 L596.8548,678.12193 L477.635,682.18625 C477.635,682.18625 481.69931,660.50991 472.21591,657.80037 C472.21591,657.80037 503.37565,649.67174 504.73042,648.31697 C506.08519,646.9622 583.30714,619.86678 588.72623,618.51197 C594.14532,617.15716 610.40256,606.31903 622.5955,607.6738 C622.5955,607.6738 636.14322,596.83563 651.0457,599.54517 L609.04774,602.25476 L578.27664,603.15633 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero",
    points: "558 609.885 572.469 642.898 660.529 611.738 667.303 594.126 644.272 590.062 597.97 598.19 577.888 603.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "558 609.885 572.469 642.898 660.529 611.738 667.303 594.126 644.272 590.062 597.97 598.19 577.888 603.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.608,649.67176 C370.608,649.67176 396.34865,682.18627 426.15362,690.31489 C455.95859,698.44351 472.21583,687.60535 472.21583,687.60535 L462.73247,649.67176 L458.66815,625.28588 L441.05615,613.09294 L405.8321,596.83569 L363.8342,583.28798 C363.8342,583.28798 346.2222,580.57844 346.2222,583.28798 C346.2222,585.99752 362.47946,626.64065 362.47946,626.64065 L370.608,649.67176 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.76777,667.28376 C401.76777,667.28376 407.18685,706.57212 413.96071,709.28166 C420.73457,711.9912 441.05613,706.57212 446.47521,703.86257 C451.89429,701.15302 470.31434,688.65194 470.31434,688.65194 C470.31434,688.65194 405.83208,664.57422 401.76777,667.28376 Z",
    id: "Path",
    fill: "#F2F2F2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB9B9",
    fillRule: "nonzero",
    points: "525.052 671.348 550.793 675.412 548.083 706.572 512.18 697.851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.17988,680.01994 C541.17988,680.01994 529.11625,694.37919 541.30919,702.50781 L549.43782,709.28167 C549.43782,709.28167 576.53324,714.70075 579.24282,717.4103 C581.9524,720.11985 592.79053,713.34598 592.79053,713.34598 C592.79053,713.34598 594.1453,672.70285 592.79053,669.99331 C591.43576,667.28377 575.17853,664.57422 573.82374,667.28377 C572.46895,669.99332 556.21174,674.05762 546.72831,671.34808 L541.17988,680.01994 Z",
    id: "Path",
    fill: "#F2F2F2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.9275,607.67384 C432.9275,607.67384 338.09353,552.12822 323.191,572.44976 C308.28847,592.7713 292.03127,621.22152 335.38394,642.89786 C378.73661,664.5742 514.21373,709.28164 514.21373,709.28164 C514.21373,709.28164 534.53529,678.1219 534.53529,669.99328 C534.53529,669.99328 462.73243,637.47877 450.53949,634.76923 C438.34655,632.05969 389.57479,600.89995 382.80093,598.19041 C376.02707,595.48087 366.54368,587.35224 366.54368,587.35224 L432.9275,607.67384 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.83208,439.68222 L400.413,443.74654 C400.413,443.74654 388.22006,474.90627 386.86529,492.5183 C385.51052,510.13033 369.25329,564.32116 370.60803,571.09502 C371.96277,577.86888 373.31757,583.28796 381.4462,590.06181 C381.4462,590.06181 392.28437,565.67593 411.2512,569.74025 L434.2823,485.74444 L405.83208,439.68222 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.5,439.68222 L606.3382,451.87516 C606.3382,451.87516 613.11206,468.13242 613.11206,472.19673 C613.11206,476.26104 626.65977,535.87097 628.01454,538.58051 C629.36931,541.29005 634.78839,575.15933 628.01454,583.28796 C621.24069,591.41659 609.04774,596.83567 609.04774,596.83567 C609.04774,596.83567 617.17637,568.38548 591.43574,567.03067 L594.14528,556.1925 L569.7594,474.90623 L595.5,439.68222 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.54162,532.95637 L408.54162,604.31737 C408.54162,613.693534 416.068864,621.333066 425.444,621.47195 L574.68172,623.68288 C583.998056,623.820912 591.721625,616.498105 592.07972,607.18763 L594.82472,535.81839 C595.002334,531.200377 593.309384,526.706002 590.129166,523.352824 C586.948948,519.999645 582.550442,518.071272 577.9295,518.0043 L425.94681,515.80165 C421.353998,515.735074 416.926289,517.512949 413.654887,520.737275 C410.383484,523.961601 408.54162,528.363076 408.54162,532.95637 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    fillRule: "nonzero",
    cx: 496.5,
    cy: 301.5,
    rx: 93.5,
    ry: 65.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574,294.5 C569.7594,261.9152 526.277344,236 494,236 C461.722656,236 420.975396,256 414,294.5 C439.202641,265.354206 466.404238,250.78131 495.604791,250.78131 C524.805345,250.78131 550.937081,265.354206 574,294.5 Z",
    id: "Oval",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    cx: 499.98867,
    cy: 570.41763,
    r: 10.83817
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.98955,568.22143 L794.98955,691.98835 C794.98955,694.11477 793.84534,694.41835 791.98577,695.44975 C785.71152,698.92957 770.24577,705.13004 751.67735,695.31663 C749.7713,694.30928 748.59782,693.96884 748.59782,691.81297 L748.59782,569.01445 C748.59782,569.01445 772.1902,578.5307 794.98955,568.22143 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#44FF46",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 771.79369,
    cy: 568.13844,
    rx: 23.19586,
    ry: 4.92606
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 619.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 0.616,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.35461,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.39545,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 3.65635,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.40347,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 4.69719,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.43629,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.17677,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.39545,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 2.91587,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.35461,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.13593,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.17677,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 4.69719,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 4.69719,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 621.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 1.17701,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.91563,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.95647,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 4.21737,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.96449,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 5.25821,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.99731,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.73779,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.95647,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.47689,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.91563,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.69695,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.73779,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 5.25821,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 5.25821,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 624.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 0.73803,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.47665,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.51749,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 3.77839,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.5255,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 4.81923,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.55833,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.29881,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.51749,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.03791,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.47665,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.25797,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.29881,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 4.81923,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 4.81923,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 626.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 1.29905,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 2.03767,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 3.07851,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 4.3394,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 5.08652,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 5.38024,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 4.11935,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.85982,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 3.07851,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.59893,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 2.03767,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.81898,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.85982,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 5.38024,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 5.38024,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 629.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 0.86007,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.59868,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.63952,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 3.90042,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.64754,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 4.94126,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.68036,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.42084,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.63952,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.15994,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.59868,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.38,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.42084,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 4.94126,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 4.94126,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 631.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 1.42108,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 2.1597,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 3.20054,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 4.46144,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 5.20856,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 5.50228,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 4.24138,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.98186,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 3.20054,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.72096,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 2.1597,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.94102,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.98186,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 5.50228,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 5.50228,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 634.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 0.9821,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.72072,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.76156,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 4.02246,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.76957,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 5.0633,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.8024,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.54288,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.76156,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.28198,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.72072,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.50204,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.54288,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 5.0633,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 5.0633,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 637.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 0.54312,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.28174,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.32258,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 3.58347,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.33059,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 4.62431,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.36342,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.10389,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.32258,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 2.843,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.28174,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.06305,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.10389,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 4.62431,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 4.62431,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 639.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 1.10414,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.84275,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.88359,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 4.14449,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.89161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 5.18533,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.92443,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.66491,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.88359,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.40401,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.84275,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.62407,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.66491,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 5.18533,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 5.18533,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 642.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 0.66515,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.40377,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.44461,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 3.70551,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.45263,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 4.74635,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.48545,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.22593,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.44461,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 2.96503,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.40377,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.18509,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.22593,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 4.74635,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 4.74635,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 644.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 1.22617,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.96479,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 3.00563,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 4.26653,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 5.01364,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 5.30737,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 4.04647,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.78695,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 3.00563,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.52605,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.96479,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.74611,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.78695,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 5.30737,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 5.30737,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 647.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 0.78719,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.52581,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.56665,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 3.82754,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.57466,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 4.86838,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.60749,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.34796,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.56665,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.08707,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.52581,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.30712,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.34796,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 4.86838,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 4.86838,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 649.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 1.34821,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 2.08682,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 3.12766,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 4.38856,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 5.13568,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 5.4294,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 4.1685,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.90898,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 3.12766,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.64808,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 2.08682,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.86814,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.90898,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 5.4294,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 5.4294,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 652.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 0.90922,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.64784,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.68868,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 3.94958,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.6967,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 4.99042,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.72952,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.68868,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.2091,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.64784,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.42916,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 4.99042,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 4.99042,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 654.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 1.47024,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 2.20886,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 3.2497,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 4.5106,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 5.25771,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 5.55144,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 4.29054,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 5.03102,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 3.2497,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.77012,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 2.20886,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.99018,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 5.03102,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 5.55144,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 5.55144,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 657.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 1.03126,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.76987,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.81071,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 4.07161,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.81873,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 5.11245,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.85155,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.59203,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.81071,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.33113,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.76987,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.55119,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.59203,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 5.11245,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 5.11245,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 660.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 0.59228,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.33089,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.37173,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 3.63263,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.37975,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 4.67347,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.41257,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.15305,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.37173,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 2.89215,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.33089,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.11221,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.15305,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 4.67347,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 4.67347,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 662.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 1.15329,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.89191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.93275,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 4.19365,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.94077,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 5.23449,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.97359,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.71407,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.93275,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.45317,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.89191,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.67323,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.71407,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 5.23449,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 5.23449,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 665.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 0.71431,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.45293,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.49377,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 3.75467,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.50178,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 4.79551,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.53461,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.27509,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.49377,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.01419,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.45293,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.23425,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.27509,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 4.79551,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 4.79551,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 667.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 1.27533,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 2.01394,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 3.05478,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 4.31568,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 5.0628,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 5.35652,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 4.09562,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.8361,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 3.05478,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.5752,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 2.01394,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.79526,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.8361,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 5.35652,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 5.35652,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 670.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 0.83635,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.57496,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.6158,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 3.8767,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.62382,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 4.91754,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.65664,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.39712,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.6158,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.13622,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.57496,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.35628,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.39712,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 4.91754,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 4.91754,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 672.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 1.39736,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 2.13598,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 3.17682,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 4.43772,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 5.18483,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 5.47856,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 4.21766,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.95814,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 3.17682,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.69724,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 2.13598,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.9173,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.95814,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 5.47856,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 5.47856,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 675.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 0.95838,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.697,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.73784,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 3.99874,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.74585,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 5.03958,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.77868,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.51916,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.73784,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 3.25826,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.697,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.47832,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.51916,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 5.03958,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 5.03958,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(750.000000, 678.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.87703,
    cy: 0.5194,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40.235,
    cy: 1.25801,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 36.97082,
    cy: 2.29885,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31.11811,
    cy: 3.55975,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.94755,
    cy: 4.30687,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.55709,
    cy: 4.60059,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.38428,
    cy: 3.33969,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.42349,
    cy: 4.08017,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.70675,
    cy: 2.29885,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.44122,
    cy: 2.81927,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.71034,
    cy: 1.25801,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.98211,
    cy: 3.03933,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.94379,
    cy: 4.08017,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.39112,
    cy: 4.60059,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.4304,
    cy: 4.60059,
    r: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice2);
export default __webpack_public_path__ + "static/media/voice2.385119df3be5bcbabe5d994cce871631.svg";
export { ForwardRef as ReactComponent };